import { MerchantAutoenrollmentInitRepository } from '@/AutoEnrollment/domain'
import { HttpModel } from '@/Shared/domain'

interface IMerchantAutoenrollmentInit {
  getMerchantAutoenrollmentInit: () => Promise<HttpModel<boolean>>
}

export const MerchantAutoenrollmentInitContract = (
  repository: MerchantAutoenrollmentInitRepository,
): IMerchantAutoenrollmentInit => ({
  getMerchantAutoenrollmentInit: () => repository.GetMerchantAutoenrollmentInit(),
})
